/**
 * SURUTTO shared scroll reveal
 * Soft float-up fade-in (same feel as asami_1_media-lp / homepage)
 */
(function () {
  if (window.suruttoRevealInit) return;
  window.suruttoRevealInit = true;

  var SELECTOR = [
    /* Home */
    '.series__header',
    '.series__card',
    '.series__panel',
    '.concept__inner',
    '.features__panel',
    '.satisfaction__header',
    '.satisfaction__score',
    '.satisfaction__lead',
    '.satisfaction__note',
    '.satisfaction__charts',
    '.satisfaction__description',
    '.satisfaction__footer',
    '.user-voice__header',
    '.user-voice__card',
    '.growave-reviews',
    '.support-panels__item',
    '.instagram__header',
    '.instagram__feed',
    '.instagram__footer',
    '.recipe__header',
    '.recipe__item',
    '.recipe__footer',
    '.blogs__header',
    '.blogs__card',
    '.blogs__footer',
    '.news__header',
    '.news__item',
    '.news__footer',
    '.contact-cta__inner',

    /* Frypan / NF LP / PRO LP */
    '.lp-features__intro',
    '.lp-features__header',
    '.lp-features__item',
    '.lp-features__hero-content',
    '.lp-concept__intro',
    '.lp-concept__stage',
    '.lp-concept__satisfaction',
    '.lp-warranty__heading',
    '.lp-warranty__subheading',
    '.lp-warranty-card',
    '.lp-reviews',
    '#MainContent .product',
    '#MainContent .collection',

    /* Brand story */
    '.bs-story__band',
    '.bs-story__stage',
    '.bs-mission__heading',
    '.bs-mission__lead',
    '.bs-mission__list',
    '.bs-mission__bridge',
    '.bs-mission__icons',
    '.bs-mission__closing',
    '.bs-promise__item',
    '.bs-journey__band',
    '.bs-journey__stage',
    '.bs-pledge__heading',
    '.bs-pledge__hero',
    '.bs-pledge__card',
    '.bs-closing__content',

    /* After service */
    '.as-section-header',
    '.as-guide-card',
    '.as-heading',
    '.as-block',
    '.as-support-card',
    '.as-care-card',
    '.as-contact .as-text',
    '.as-contact .as-actions',

    /* How to choose */
    '.sg-heading',
    '.sg-section-header',
    '.sg-shortcut-card',
    '.sg-series-card',
    '.sg-size-block',
    '.sg-size-card',
    '.sg-cook-card',
    '.sg-scene-card',
    '.sg-attention',

    /* Shared modules on those pages */
    '.faq-accordion__header',
    '.faq-search-wrap',
    '.faq-accordion__panel',
    '.faq-accordion__category-heading',
    '.su-cmp__header',
    '.su-cmp__product',
    '.su-cmp__row'
  ].join(',');

  function markVisible(el) {
    el.classList.add('is-visible');
  }

  function init() {
    var items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (el) {
      el.classList.add('su-reveal');
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(items, markVisible);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, markVisible);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          markVisible(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0
      }
    );

    Array.prototype.forEach.call(items, function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
